/**
 * Single source of truth for "what scope is this URL". The shell, sidebar, and
 * context switcher all derive from this — never from the picker's value. Keeps
 * Provider (cross-tenant) and Integrator (one tenant) views from desyncing.
 */
export type Scope =
  | { mode: 'provider' }
  | { mode: 'integrator'; integratorId: string };

const SCOPE_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

/** Parse a path (query/hash tolerated) into a scope verdict. */
export function deriveScope(rawPath: string): Scope {
  const path = rawPath.split('?')[0]!.split('#')[0]!;
  const m = path.match(/^\/integrators\/([^/]+)(?:\/.*)?$/);
  if (m && m[1] && SCOPE_UUID_RE.test(m[1])) {
    return { mode: 'integrator', integratorId: m[1] };
  }
  // `/integrators` (no id), non-UUID segments, and every other route is provider scope.
  return { mode: 'provider' };
}
